"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Property = exports.CITIZENSHIP_QUESTION_PREFIX = exports.PropertyUnitsOfMeasure = exports.PropertyUnitOfMeasure = exports.PropertyNumberFormat = exports.PropertyLocale = void 0;
exports.getCitizenshipQuestion = getCitizenshipQuestion;
exports.getCitizenshipQuestionWithCountryFallback = getCitizenshipQuestionWithCountryFallback;
exports.getParentChildPropertyIds = getParentChildPropertyIds;
var PropertyLocale = /** @class */ (function () {
    function PropertyLocale() {
        this.localeCode = '';
        this.localeName = '';
        this.isDefault = false;
    }
    return PropertyLocale;
}());
exports.PropertyLocale = PropertyLocale;
var PropertyNumberFormat = /** @class */ (function () {
    function PropertyNumberFormat() {
    }
    return PropertyNumberFormat;
}());
exports.PropertyNumberFormat = PropertyNumberFormat;
var PropertyUnitOfMeasure = /** @class */ (function () {
    function PropertyUnitOfMeasure() {
    }
    return PropertyUnitOfMeasure;
}());
exports.PropertyUnitOfMeasure = PropertyUnitOfMeasure;
var PropertyUnitsOfMeasure = /** @class */ (function () {
    function PropertyUnitsOfMeasure() {
    }
    return PropertyUnitsOfMeasure;
}());
exports.PropertyUnitsOfMeasure = PropertyUnitsOfMeasure;
exports.CITIZENSHIP_QUESTION_PREFIX = 'Are you a citizen of';
var ENGLISH_COUNTRY_LOCALE = 'en-US';
var DEFAULT_COUNTRY_CODE = 'US';
function getLocaleCountryCode(localeCode) {
    var _a, _b, _c;
    return (_c = (_b = (_a = localeCode === null || localeCode === void 0 ? void 0 : localeCode.trim().match(/[-_]([A-Za-z]{2})$/)) === null || _a === void 0 ? void 0 : _a[1]) === null || _b === void 0 ? void 0 : _b.toUpperCase()) !== null && _c !== void 0 ? _c : '';
}
function getCountryName(config) {
    var _a, _b;
    var countryCode = (_a = config.countryCode) === null || _a === void 0 ? void 0 : _a.trim().toUpperCase();
    if (!countryCode)
        return '';
    try {
        return ((_b = new Intl.DisplayNames([ENGLISH_COUNTRY_LOCALE], {
            type: 'region',
        }).of(countryCode)) !== null && _b !== void 0 ? _b : countryCode);
    }
    catch (_c) {
        return countryCode;
    }
}
function getCitizenshipQuestion(config, fallback) {
    var _a;
    if (fallback === void 0) { fallback = exports.CITIZENSHIP_QUESTION_PREFIX; }
    var country = config ? getCountryName(config) : '';
    var configuredQuestion = (_a = config === null || config === void 0 ? void 0 : config.citizenshipQuestion) === null || _a === void 0 ? void 0 : _a.trim();
    if (configuredQuestion &&
        (!country || configuredQuestion.includes(country))) {
        return configuredQuestion;
    }
    if (country)
        return "".concat(exports.CITIZENSHIP_QUESTION_PREFIX, " ").concat(country, "?");
    return configuredQuestion || fallback || exports.CITIZENSHIP_QUESTION_PREFIX;
}
function getCitizenshipQuestionWithCountryFallback(config, fallbackCountryCode, fallback) {
    var _a, _b, _c, _d;
    if (fallbackCountryCode === void 0) { fallbackCountryCode = ''; }
    if (fallback === void 0) { fallback = exports.CITIZENSHIP_QUESTION_PREFIX; }
    var configuredQuestion = (_a = config === null || config === void 0 ? void 0 : config.citizenshipQuestion) === null || _a === void 0 ? void 0 : _a.trim();
    if (configuredQuestion && !((_b = config === null || config === void 0 ? void 0 : config.countryCode) === null || _b === void 0 ? void 0 : _b.trim()))
        return configuredQuestion;
    var countryCode = ((_c = config === null || config === void 0 ? void 0 : config.countryCode) === null || _c === void 0 ? void 0 : _c.trim()) ||
        getLocaleCountryCode(config === null || config === void 0 ? void 0 : config.localeCode) ||
        fallbackCountryCode.trim().toUpperCase() ||
        DEFAULT_COUNTRY_CODE;
    return getCitizenshipQuestion(__assign(__assign({}, config), { countryCode: countryCode, taxIdTypes: (_d = config === null || config === void 0 ? void 0 : config.taxIdTypes) !== null && _d !== void 0 ? _d : [] }), fallback);
}
var Property = /** @class */ (function () {
    function Property() {
        this.propertyId = 0;
        this.propertyName = '';
    }
    return Property;
}());
exports.Property = Property;
/**
 * Returns every property involved in a parent/child relationship. A child is
 * identified by its `parentPropertyId`; the referenced property is its
 * parent. Standalone properties are not included.
 */
function getParentChildPropertyIds(properties) {
    var relatedPropertyIds = new Set();
    for (var _i = 0, properties_1 = properties; _i < properties_1.length; _i++) {
        var property = properties_1[_i];
        var parentPropertyId = property.parentPropertyId;
        if (typeof parentPropertyId !== 'number' ||
            !Number.isInteger(parentPropertyId) ||
            parentPropertyId <= 0) {
            continue;
        }
        relatedPropertyIds.add(property.propertyId);
        relatedPropertyIds.add(parentPropertyId);
    }
    return relatedPropertyIds;
}
